import { Link, Script } from "gatsby";
import { useContext, useEffect, useState } from "react";
import MegaMenu from "../menu/mega-menu";
import HamburgerMenu from "../menu/hamburger-menu";
import { StateContext, MenuContext } from "../../lib/store";
import { Logo } from "../logo";
import SiteContext from "../../store/SiteContext";

const currentYear = new Date().getFullYear();

function Header({
  cssClass,
  page,
  nav: oldNav,
  isHamburgerOnly: oldIsHamburgerOnly,
  ctas: oldCtas,
  miscLinks: oldMiscLinks,
  section,
}) {
  // TODO - Remove StateContext and just use menuContext and siteContext we can then move footer data into FooterContext
  const [menuState, menuDispatch] = useContext(MenuContext);
  const [header, setHeader] = useState("header");
  const [state, dispatch] = useContext(StateContext);
  const siteContext = useContext(SiteContext);
  let currentMenu = null;
  let nav = oldNav;
  let ctas = oldCtas;
  let miscLinks = oldMiscLinks;
  let isHamburgerOnly = oldIsHamburgerOnly;

  //console.log("menuState", menuState);

  if (page !== undefined && page.path && nav?.length) {
    for (let i = 0; i < nav.length; i++) {
      if (page.path.startsWith(nav[i].startsWith)) {
        currentMenu = i;
      }
    }
  }

  // Replace mega menu nav if available
  if (
    menuState &&
    Array.isArray(menuState?.megaMenu) &&
    menuState?.megaMenu?.length > 0
  ) {
    nav = menuState.megaMenu;
    isHamburgerOnly = menuState.isHamburgerOnly;
  }

  // Replace ctas if available
  if (
    menuState &&
    Array.isArray(menuState?.ctaMenu) &&
    menuState?.ctaMenu?.length > 0
  ) {
    ctas = menuState.ctaMenu;
    // console.log("ctas", ctas);
    // console.log("menuState.ctaMenu", menuState.ctaMenu);
  }

  // Replace misc links if available
  if (
    menuState &&
    Array.isArray(menuState?.miscMenu) &&
    menuState?.miscMenu?.length > 0
  ) {
    miscLinks = menuState.miscMenu;
    // console.log("miscLinks", oldMiscLinks);
    // console.log("menuState.miscMenu", menuState.miscMenu);
  }

  const hamburgerNav = [];

  // Hamburger Menu Data
  for (let i = 0; i < nav?.length; i++) {
    const item = nav[i];
    hamburgerNav[i] = {};
    hamburgerNav[i].label = item?.label;
    hamburgerNav[i].url = item?.url;
    hamburgerNav[i].children = [];

    if (Array.isArray(item.columns)) {
      for (let x = 0; x < item.columns.length; x++) {
        const column = item.columns[x];
        for (let y = 0; y < column.length; y++) {
          hamburgerNav[i].children.push(column[y]);
        }
      }
    }
  }

  const listenScrollEvent = () => {
    if (window.scrollY <= 30) {
      return setHeader("");
    }
    return setHeader("bg-blue-500 border-b-4 border-yellow-500");
  };

  // Component Did Mount (Initialization Code Goes Here)
  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent, false);
    listenScrollEvent();
    dispatch({
      type: "UPDATE_GLOBAL_STATE",
      data: {
        megaMenu: {
          nav: isHamburgerOnly ? [] : nav,
          currentMenu,
          columns: null,
        },
        hamburgerMenu: {
          nav: hamburgerNav,
          buttons: Array.isArray(ctas) ? ctas : [],
          currentMenu: null,
          isOpen: false,
          miscLinks: Array.isArray(miscLinks) ? miscLinks : [],
        },
        // TODO: Finish hooking up footer menu store
        footerMenu: {
          logo: {},
          contactInfo: {},
          socialLinks: [],
          mainLinks: hamburgerNav,
          miscLinks: Array.isArray(miscLinks) ? miscLinks : [],
          ctas: Array.isArray(ctas) ? ctas : [],
          copyright: {
            year: `© ${currentYear}`,
            website: {
              label: "Rollins College",
              url: "https://www.rollins.edu/",
            },
            links: [
              {
                label: "Privacy Policy",
                target: "_blank",
                url: "https://www.rollins.edu/the-fine-print/privacy-policy",
              },
            ],
          },
        },
      },
    });

    document.addEventListener("click", handleClickOutside);
  }, []);

  const handleClickOutside = (evt) => {
    if (
      !(
        evt.target.classList.contains("mega-menu") ||
        evt.target.closest(".mega-menu") ||
        evt.target.classList.contains("nav-item")
      )
    ) {
      // If mega menu is present click active mega menu nav item to toggle the close action
      if (document.querySelector(".mega-menu")) {
        document.querySelector(".nav-item.text-yellow-500")?.click();
      }
    }
  };

  // now using siteContext, but patching legacy code.
  const logoLinkUrl =
    typeof siteContext?.site.urlPrefix === "string" &&
    siteContext?.site.urlPrefix.length > 0
      ? `${siteContext.site.urlPrefix}`
      : page?.section?.urlPrefix
      ? page.section.urlPrefix
      : page?.section?.sectionSlug?.current
      ? `/${page.section.sectionSlug.current}/`
      : section?.sectionSlug?.current
      ? `/${section?.sectionSlug?.current}`
      : `/college-of-liberal-arts`;

  return (
    <>
      <header className={`fixed z-40 w-full ${header} ${cssClass}`}>
        {(page?.section?.sectionSlug?.current === "graduate" ||
          page?.section?.sectionSlug?.current ===
            "professional-advancement") && (
          <Script
            type="text/javascript"
            src="https://bot.ivy.ai/bot/script/category/oZqgB5JbYLDWmyM4BglnzR3Q2rav8eAX"
            referrerPolicy="no-referrer-when-downgrade"
            async
          />
        )}
        <div className="flex flex-wrap justify-between max-w-6xl p-3 py-5 mx-auto">
          <a href={logoLinkUrl}>
            <p className="flex text-white no-underline">
              <Logo section={page?.section ?? section} />
            </p>
          </a>
          <nav className="text-sm mt-2 ml-auto flex items-center w-auto relative">
            <div className="hidden lg:flex">
              {state.megaMenu.nav.map((navItem, index) => {
                return navItem.url ? (
                  <a
                    key={`nav-item:${index}`}
                    className={`${
                      state.megaMenu.currentMenu === index
                        ? "text-yellow-500"
                        : ""
                    } block mt-4 tracking-tight font-bold text-white no-underline hover:text-yellow-500 lg:inline-block lg:mt-0 lg:ml-6`}
                    href={navItem.url}
                    onClick={() =>
                      dispatch({
                        type: "UPDATE_MEGA_MENU",
                        data: { columns: null, currentMenu: index },
                      })
                    }
                    activeClassName={
                      state.megaMenu.currentMenu === index
                        ? "text-yellow-500"
                        : ""
                    }
                    partiallyActive
                  >
                    {navItem.label}
                  </a>
                ) : (
                  <a
                    key={`nav-item:${index}`}
                    href={navItem.url}
                    id={`main-nav--nav-item--${navItem.label}`}
                    className={`${
                      state.megaMenu.currentMenu === index
                        ? "text-yellow-500"
                        : ""
                    } nav-item flex cursor-pointer block mt-4 tracking-tight font-bold items-center text-white no-underline hover:text-yellow-500 lg:inline-block lg:mt-0 lg:ml-6`}
                    onClick={() => {
                      let columns = navItem.columns;
                      let currentMenu = index;
                      if (state.megaMenu.currentMenu === index) {
                        columns = null;
                        currentMenu = null;
                      }
                      dispatch({
                        type: "UPDATE_MEGA_MENU",
                        data: {
                          columns,
                          currentMenu,
                        },
                      });
                    }}
                  >
                    {navItem.label}
                  </a>
                );
              })}
            </div>
            <a
              className="search cursor-pointer block mt-4 tracking-tight font-bold text-white no-underline hover:text-yellow-500 lg:inline-block lg:mt-0 lg:ml-8  hidden lg:flex"
              onClick={() =>
                dispatch({
                  type: "UPDATE_HAMBURGER_MENU",
                  data: {
                    isOpen: !state.hamburgerMenu.isOpen,
                  },
                })
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                className="h-6 w-6 fill-current"
              >
                <path d="M17.545 15.467l-3.779-3.779a6.15 6.15 0 0 0 .898-3.21c0-3.417-2.961-6.377-6.378-6.377A6.185 6.185 0 0 0 2.1 8.287c0 3.416 2.961 6.377 6.377 6.377a6.15 6.15 0 0 0 3.115-.844l3.799 3.801a.953.953 0 0 0 1.346 0l.943-.943c.371-.371.236-.84-.135-1.211zM4.004 8.287a4.282 4.282 0 0 1 4.282-4.283c2.366 0 4.474 2.107 4.474 4.474a4.284 4.284 0 0 1-4.283 4.283c-2.366-.001-4.473-2.109-4.473-4.474z" />
              </svg>
            </a>
            <a
              id="hamburger-icon-1"
              className="hamburger cursor-pointer block tracking-tight font-bold text-white no-underline hover:text-yellow-500 inline-block mt-0 ml-3"

              onClick={() =>
                dispatch({
                  type: "UPDATE_HAMBURGER_MENU",
                  data: {
                    isOpen: !state.hamburgerMenu.isOpen,
                  },
                })
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                className="h-6 w-6 fill-current"
              >
                <path d="M16.4 9H3.6c-.552 0-.6.447-.6 1 0 .553.048 1 .6 1h12.8c.552 0 .6-.447.6-1 0-.553-.048-1-.6-1zm0 4H3.6c-.552 0-.6.447-.6 1 0 .553.048 1 .6 1h12.8c.552 0 .6-.447.6-1 0-.553-.048-1-.6-1zM3.6 7h12.8c.552 0 .6-.447.6-1 0-.553-.048-1-.6-1H3.6c-.552 0-.6.447-.6 1 0 .553.048 1 .6 1z" />
              </svg>
            </a>
          </nav>
        </div>
        {state.megaMenu.columns && state.megaMenu.columns.length > 0 && (
          <MegaMenu cssClass="mega-menu" columns={state.megaMenu.columns} />
        )}
      </header>
      <HamburgerMenu
        isHamburgerOnly={isHamburgerOnly}
        showSearch={true}
        showMiscLinks={true}
      />
    </>
  );
}

export default Header;
